// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"bd8fc57b","236":"c461db98","311":"5e85c0de","379":"970d3a89","863":"ebdb4c9c","941":"21e83b45","967":"045caf01"}[chunkId] + ".chunk.js";
};